<script setup>
import {ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    oldValue: Number,
    newValue: Number
})

const itemDataStore = useItemDataStore()

const oldPageName = ref(null)

watch(
    () => props.oldValue,
    async (val) => {
        if (!val) {
            oldPageName.value = null
            return
        }
        const obj = await itemDataStore.get({
            tableName: 'pages',
            id: val
        })
        oldPageName.value = obj?.title ?? null
    },
    {immediate: true}
)

const newPageName = ref(null)

watch(
    [() => props.oldValue, () => props.newValue],
    async () => {
        if (!props.oldValue || !props.newValue) {
            newPageName.value = null
            return
        }
        const obj = await itemDataStore.get({
            tableName: 'pages',
            id: props.newValue
        })
        newPageName.value = obj?.title ?? null
    },
    {immediate: true}
)
</script>

<template>
    <div class="d-flex align-items-center">
        <small v-if="oldPageName" class="border rounded py-1 px-2" v-html="oldPageName"></small>
        <i v-else-if="oldValue" class="small">page #{{ newValue }} not found</i>
        <i v-else class="small">empty</i>

        <i class="mx-2 bi-chevron-right"/>

        <small v-if="newPageName" class="border rounded py-1 px-2" v-html="newPageName"></small>
        <i v-else-if="newValue" class="small">page #{{ newValue }} not found</i>
        <i v-else class="small">empty</i>
    </div>
</template>